<template>
  <a
    ref="paginationButton"
    :href="`?page=${number}`"
    :aria-current="current ? 'page' : 'false'"
    :class="[
      current
        ? 'bg-default-with-transparency border-default text-default z-10'
        : 'border-gray-400 bg-white text-gray-700 hover:bg-gray-50',
      'focus:border-default focus:outline-default relative inline-flex items-center border px-4 py-2 text-sm font-medium focus:z-10 focus:outline-2',
    ]"
    @click.prevent="onClick"
  >
    {{ number }}
  </a>
</template>

<script setup>
import { ref, computed, toRefs } from 'vue'
import { useMainStore } from '../store'

const props = defineProps({
  number: {
    type: Number,
    default: 0,
  },
  current: Boolean,
  onClick: {
    type: Function,
    default: () => {},
  },
})

const paginationButton = ref(null)

const { current, number } = toRefs(props)

const store = useMainStore()
const bgColor = computed(() => `${store.themeVariables['--default']}10`)
</script>

<style>
.bg-default-with-transparency {
  background-color: v-bind(bgColor);
}
</style>
